import { __extends } from "tslib";
import { Debug } from '@awayjs/core';
import { ContentElement } from './ContentElement';
var noLogs = true;
var GroupElement = /** @class */ (function (_super) {
    __extends(GroupElement, _super);
    function GroupElement(elements, elementFormat, eventMirror, textRotation) {
        if (elements === void 0) { elements = null; }
        if (elementFormat === void 0) { elementFormat = null; }
        if (eventMirror === void 0) { eventMirror = null; }
        if (textRotation === void 0) { textRotation = 'rotate0'; }
        var _this = _super.call(this, elementFormat, eventMirror, textRotation) || this;
        _this._elements = elements ? elements._buffer : [];
        noLogs || console.log('[GroupElement] ' + _this._id + ' constructor', 'elements', elements);
        return _this;
    }
    GroupElement.prototype.setTextBlock = function (value) {
        noLogs || console.log('[GroupElement]  ' + this._id + ' - set textBlock', value);
        _super.prototype.setTextBlock.call(this, value);
        for (var i = 0; i < this._elements.length; i++) {
            this._elements[i].setTextBlock(value);
            this._elements[i].setGroupElement(this);
        }
    };
    Object.defineProperty(GroupElement.prototype, "elementCount", {
        // AS -> JS Bindings
        // _elementCount: number /*int*/;
        get: function () {
            noLogs || console.log('[GroupElement]  ' + this._id + ' - elementCount', this._elements.length);
            return this._elements.length;
        },
        enumerable: true,
        configurable: true
    });
    GroupElement.prototype.getElementAt = function (index /*int*/) {
        noLogs || console.log('[GroupElement]  ' + this._id + ' - getElementAt', index, this._elements[index]);
        return this._elements[index];
    };
    GroupElement.prototype.setElements = function (value /*ASVector<any>*/) {
        //value = value;
        noLogs || console.log('[GroupElement]  ' + this._id + ' - setElements', value);
        this._elements = value._buffer;
        for (var i = 0; i < this._elements.length; i++) {
            this._elements[i].setTextBlock(this._textBlock);
            this._elements[i].setGroupElement(this);
        }
        if (this._textBlock)
            this._textBlock.setTextDataDirty();
    };
    GroupElement.prototype.groupElements = function (beginIndex /*int*/, endIndex /*int*/) {
        //beginIndex = beginIndex | 0;
        //endIndex = endIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/engine/GroupElement', 'groupElements', '');
        return null;
    };
    GroupElement.prototype.ungroupElements = function (groupIndex /*int*/) {
        //groupIndex = groupIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/engine/GroupElement', 'ungroupElements', '');
    };
    GroupElement.prototype.mergeTextElements = function (beginIndex /*int*/, endIndex /*int*/) {
        //beginIndex = beginIndex | 0;
        //endIndex = endIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/engine/GroupElement', 'mergeTextElements', '');
        return null;
    };
    GroupElement.prototype.splitTextElement = function (elementIndex /*int*/, splitIndex /*int*/) {
        //elementIndex = elementIndex | 0;
        //splitIndex = splitIndex | 0;
        // @todo
        Debug.throwPIR('playerglobals/text/engine/GroupElement', 'groupElements', '');
        return null;
    };
    GroupElement.prototype.replaceElements = function (beginIndex /*int*/, endIndex /*int*/, newElements /*ASVector<any>*/) {
        noLogs || console.log('[GroupElement]  ' + this._id + ' - replaceElements', 'beginIndex', beginIndex, 'endIndex', endIndex, 'newElements', newElements);
        var cnt = 0;
        if (endIndex - beginIndex > newElements._buffer.length) {
            console.warn('[GroupElement] - replaceElements error with range and vector size');
        }
        for (var i = beginIndex; i <= endIndex; i++) {
            this._elements[i] = newElements._buffer[cnt++];
        }
        for (var i = 0; i < this._elements.length; i++) {
            this._elements[i].setTextBlock(this._textBlock);
            this._elements[i].setGroupElement(this);
        }
        if (this._textBlock)
            this._textBlock.setTextDataDirty();
        return newElements;
    };
    GroupElement.prototype.getElementAtCharIndex = function (charIndex /*int*/) {
        //charIndex = charIndex | 0;
        noLogs || console.log('[GroupElement]  ' + this._id + ' - getElementAtCharIndex', charIndex);
        return null;
    };
    GroupElement.forceNativeConstructor = true;
    GroupElement.forceNativeMethods = true;
    return GroupElement;
}(ContentElement));
export { GroupElement };
